import type { ChangelogEntry } from "../types";

/** Ny Måltall, oppfølging: pipeline-alder, velgere i Mine tall og «Spør om tallene». */
export const MALTALL_OPPFOLGING_2026_10: ChangelogEntry = {
  id: "2026-10-28-maltall-oppfolging",
  date: "2026-10-28",
  title: "Spør om tallene, og mer i ny Måltall",
  summary: "Ledelsen kan stille spørsmål om tallene, pipen viser hvor gamle tilbudene er, og Mine tall kan vises per måned eller kvartal.",
  sections: [
    {
      heading: "Måltall",
      items: [
        {
          title: "Hvor gamle tilbudene i pipen er",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          minRole: "admin",
          body: "Klikk på GEEK i tilbudspipe for å se tilbudene fordelt på siste 30 dager, 31–90 dager og over 90 dager siden de ble sendt, og hvilke kunder som har flere tilbud ute samtidig.",
        },
        {
          title: "Mine tall per måned eller kvartal",
          kind: "nytt",
          featureFlag: "feature_maaltall_v2",
          body: "Faktureringsgraden i Mine tall kan vises per måned eller per kvartal. Budsjettavviket kan vises for denne måneden, dette kvartalet eller hittil i år.",
        },
        {
          title: "Budsjettavvik viser alle ansatte",
          kind: "forbedret",
          featureFlag: "feature_maaltall_v2",
          minRole: "admin",
          body: "Budsjettavvik ved siden av feilbudsjettering per produkt viser nå alle ansatte, med størst avvik først, i stedet for de fem største.",
        },
        {
          title: "«Estimert rest» heter nå «Estimert ordrereserve»",
          kind: "forbedret",
          featureFlag: "feature_maaltall_v2",
          minRole: "admin",
          body: "I prognosen for fakturering og GEEK heter salgssummen som ikke er fakturert ennå nå «Estimert ordrereserve». Tallet regnes som før.",
        },
        {
          title: "Spør om tallene",
          kind: "nytt",
          featureFlag: "feature_maaltall_agent",
          minRole: "admin",
          body: "Still spørsmål om tallene på Måltall og få svar med de samme beregningene som widgetene, med kildene under. Forslag til tiltak kommer bare fra de faste sjekkene. Navn på ansatte byttes ut før spørsmålet sendes, og alt logges.",
        },
      ],
    },
  ],
};
